import { Typography, Box, useTheme } from "@mui/material";
import { tokens } from "../theme";

const Header = ({ title, subtitle, icon, dense = false }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box mb={dense ? 2 : 3} display="flex" alignItems="center" gap={1.5}>
      {icon && (
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: 1.25,
            backgroundColor: "rgba(27, 54, 93, 0.08)",
            color: 'var(--fx-text-primary)',
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            "& svg": { fontSize: 18 },
          }}
        >
          {icon}
        </Box>
      )}
      <Box>
        <Typography
          variant="h3"
          sx={{
            color: 'var(--fx-text-primary)',
            fontWeight: 700,
            fontSize: dense ? "1.0625rem" : "1.25rem",
            letterSpacing: "-0.01em",
            lineHeight: 1.2,
            m: 0,
          }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography
            sx={{
              color: colors.grey[500],
              fontSize: "0.8125rem",
              fontWeight: 400,
              mt: 0.25,
            }}
          >
            {subtitle}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default Header;
